import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './ServerError.module.scss';

export default function ServerError() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.notfound}>
                <div className={styles.notfound404}>
                    <h1>Oops!</h1>
                    <h2>500 - Our server is on a break</h2>
                </div>
                <NavLink to='/app' className={styles.goToHomeBtn}>
                    Go TO Homepage
                </NavLink>
            </div>
        </div>
    );
}
